export default __webpack_public_path__ + "static/media/4ef737d23621d18587cc06120f55ac0c1576755252439.c2d712d6.webp";